// create async functions for asking at crew3 api if address is whitelisted, on waitlist, giving the rank or neither
// one function isOnWaitlist, the other is   waitlistRank,

import axios from 'axios'
import { accountStateBackendUrl } from './waitlist-api'

export interface Zealy {
  address: string
  zealyId?: string
  rank?: number
  xp?: number
  role?: string
}

export async function zealyStatus(address: string): Promise<false | Zealy> {
  const result = (
    await axios.get(`${accountStateBackendUrl}/zealy?address=${address}`)
  ).data
  if (result === false) return false
  else {
    result.zealyId = result.id
    return result as Zealy
  }
}
